import PropTypes from "prop-types";

/**
 * Loading overlay component with dark background and centered spinner
 * Covers the entire viewport with a semi-transparent overlay
 *
 * @component
 * @param {Object} props
 * @param {string} [props.message] - Optional loading message to display
 */
const LoadingOverlay = ({ message }) => {
  return (
    <div className="preloader-wrapper" style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}>
      <div className="preloader">
        <span></span>
        <span></span>
      </div>
      {message && (
        <div
          style={{
            position: "absolute",
            top: "60%",
            left: "50%",
            transform: "translateX(-50%)",
            color: "#fff",
            fontSize: "16px",
            marginTop: "20px",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

LoadingOverlay.propTypes = {
  message: PropTypes.string,
};

export default LoadingOverlay;
